import { DependencyList, useEffect } from "react";
import ReactGA from "react-ga4";

import { config } from "../../../config";
import {
  AnalyticsEffectCallback,
  CustomEventProperties,
  GA4Events
} from "./google-analytics.types";

export const useAnalyticsInit = () => {
  const { gaMeasurementId } = config;

  useEffect(() => {
    if (!gaMeasurementId || ReactGA.isInitialized) return;
    ReactGA.initialize(gaMeasurementId, {
      gaOptions: {
        // See: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#create
      }
    });
  }, [gaMeasurementId]);
};

export const useAnalyticsEffect = (
  effect?: AnalyticsEffectCallback,
  deps: DependencyList = []
) => {
  const { gaMeasurementId } = config;

  if (!ReactGA.isInitialized && gaMeasurementId) {
    ReactGA.initialize(gaMeasurementId, {
      gaOptions: {
        // See: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#create
      }
    });
  }

  useEffect(() => {
    if (!gaMeasurementId) return;
    effect &&
      effect({
        set: ReactGA.set,
        send: ReactGA.send,
        event: (name: GA4Events, params?: CustomEventProperties) =>
          ReactGA.event(name, params)
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gaMeasurementId, ...deps]);

  return (name: GA4Events, params?: CustomEventProperties) =>
    ReactGA.event(name, params);
};
